import type { BadgeProps } from '@/shared/ui/badge';
import type { CampaignStatus, RecipientStatus } from './types';

export const CAMPAIGN_STATUS_META: Record<
  CampaignStatus,
  { label: string; variant: NonNullable<BadgeProps['variant']> }
> = {
  draft: { label: 'Rascunho', variant: 'secondary' },
  scheduled: { label: 'Agendada', variant: 'info' },
  sending: { label: 'Em envio', variant: 'warning' },
  sent: { label: 'Enviada', variant: 'success' },
  paused: { label: 'Pausada', variant: 'warning' },
  failed: { label: 'Falha', variant: 'destructive' },
  cancelled: { label: 'Cancelada', variant: 'outline' },
};

export const RECIPIENT_STATUS_META: Record<
  RecipientStatus,
  { label: string; variant: NonNullable<BadgeProps['variant']> }
> = {
  queued: { label: 'Na fila', variant: 'secondary' },
  delivered: { label: 'Entregue', variant: 'info' },
  opened: { label: 'Aberto', variant: 'success' },
  clicked: { label: 'Clique', variant: 'success' },
  rejected: { label: 'Rejeitado', variant: 'destructive' },
  unsubscribed: { label: 'Descadastro', variant: 'warning' },
};

export type CampaignActionId =
  | 'edit'
  | 'view'
  | 'results'
  | 'duplicate'
  | 'delete'
  | 'pause'
  | 'resume'
  | 'cancel';

export const ACTION_LABEL: Record<CampaignActionId, string> = {
  edit: 'Editar',
  view: 'Ver campanha',
  results: 'Ver resultados',
  duplicate: 'Duplicar',
  delete: 'Excluir',
  pause: 'Pausar',
  resume: 'Retomar',
  cancel: 'Cancelar envio',
};

export function actionsForStatus(status: CampaignStatus): CampaignActionId[] {
  switch (status) {
    case 'draft':
      return ['edit', 'duplicate', 'delete'];
    case 'scheduled':
      return ['view', 'pause', 'cancel'];
    case 'sending':
      return ['results', 'pause'];
    case 'sent':
      return ['results', 'duplicate'];
    case 'paused':
      return ['view', 'resume', 'cancel'];
    case 'failed':
      return ['view', 'duplicate'];
    case 'cancelled':
      return ['view', 'duplicate'];
    default: {
      const unreachable: never = status;
      return unreachable;
    }
  }
}
